import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { payrollEndpoints } from "@/features/payroll/api/endpoints";
import type { PayrollBatchStatsResponseDto } from "@/features/payroll/api/dto";

interface Params {
  /** Borne basse (ISO date-time) sur la date de création des paies. */
  from?: string;
  /** Borne haute (ISO date-time). */
  to?: string;
  enabled?: boolean;
}

/**
 * Tableau de bord payroll (`GET /PayrollBatches/stats?from&to`) : nombre de
 * paies, paies payées, salariés payés (membres / non-membres), masse salariale
 * brute, frais, total débité sur la période.
 */
export const usePayrollBatchStats = ({ from, to, enabled = true }: Params = {}) =>
  useQuery({
    queryKey: QUERY_KEYS.PAYROLL_BATCH_STATS(from, to),
    queryFn: () => {
      const queryParams: Record<string, string> = {};
      if (from) queryParams.from = from;
      if (to) queryParams.to = to;
      return fetchDataGet<PayrollBatchStatsResponseDto>({
        url: payrollEndpoints.payrollBatches.stats,
        queryParams,
      });
    },
    enabled,
  });
